import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=bd44413a&scoped=true&"
import script from "./LandingHeader.vue?vue&type=script&lang=js&"
export * from "./LandingHeader.vue?vue&type=script&lang=js&"
import style0 from "./LandingHeader.vue?vue&type=style&index=0&id=bd44413a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../igs3-fontend-prod353/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd44413a",
  null
  
)

export default component.exports